import { useEffect, useState } from 'react';

/**
 * Holds a value still for `delay` ms after it stops changing.
 *
 * Used where a keystroke would otherwise be a request: the certificate-number preview
 * round-trips to the server so that what an administrator reads is produced by the
 * generator itself rather than a second implementation in the browser.
 */
export function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}
